const expirySeparator = '{-expiry-}'

export default {
  setItem(key, value, expiresIn = 0, expiryDate) {
    console.assert(typeof expiresIn === 'number', 'expiresIn should be of numeric type [as in expires in x ms]')
    console.assert(key !== undefined && value !== undefined, 'key and value must not be undefined')

    if (expiryDate) {
      expiresIn = `${expiryDate}${expirySeparator}`
    } else {
      expiresIn = expiresIn ? `${expiresIn + Date.now()}${expirySeparator}` : ''
    }

    try {
      sessionStorage.setItem(key, `${expiresIn}${JSON.stringify(value)}`)
      return true
    } catch (error) {
      console.warn('Session storage not supported by browser')
      return false
    }
  },
  getItem(key, returnExpiration = false) {
    const fromSession = sessionStorage.getItem(key)
    if (!fromSession) {
      return null
    }

    const expirationAndItem = fromSession.split(expirySeparator)
    const item = expirationAndItem[1] || expirationAndItem[0]
    const expiration = expirationAndItem.length === 2 ? parseInt(expirationAndItem[0]) : null

    if (expiration && Date.now() > expiration) {
      sessionStorage.removeItem(key)
      return null
    }
    try {
      return returnExpiration ? { item: JSON.parse(item), expiration } : JSON.parse(item)
    } catch (e) {
      return returnExpiration ? { item, expiration } : item
    }
  },
  removeItem(key) {
    sessionStorage.removeItem(key)
  },
}
